import { Component } from "@angular/core";
import { LoginService } from "../services/login/login.service";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import Swal from "sweetalert2";
@Component({
  selector: 'app-recuperar-cuenta',
  templateUrl: './recuperar-cuenta.component.html',
  styleUrls: ['./recuperar-cuenta.component.css']
})
export class RecuperarCuentaComponent   {
  
  form: FormGroup;
  loading:boolean = false;
  recover:boolean = false;
  constructor(private loginService: LoginService, private router: Router) {
    this.form = new FormGroup({
      Usuario: new FormControl("", [Validators.required]),
      Ruc: new FormControl({ value: "20600742656", disabled: true }, [Validators.required]),
      idEmpresa_Factor: new FormControl({ value: "6", disabled: true }, [Validators.required])
    });
  }



  guardarCambios() {
    this.loading = true;
      this.loginService.recuperarCuenta(this.form.getRawValue()).subscribe(
        resp => {
          this.loading = false;
          this.recover = true;
          this.form.disable();
        },
        err => {
          this.loading = false;
          let title;
          let mesage; 
          if(err.status == 0){
              title = "Error de comunicación";
              mesage = "Ocurrió un error, por favor vuelve a intentarlo en unos minutos.";
          }else{
            title = "Ocurrió un error.";
            mesage = err.error;
          }
          Swal.fire({
            title: title,
            text: mesage,
            type: "error",
            allowOutsideClick: true
          });          
        }
      );
  }

}
